import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ktostamm-kunde-detail-view',
  imports: [],
  templateUrl: './ktostamm-kunde.detail-view.html',
  styleUrls: ['./ktostamm-kunde.detail-view.css'],
})
export class KtostammKundeDetailView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
